const createToolSet = async ({ commit, rootGetters, dispatch }, payload) => {
    commit("SET_CREATE_TOOL_SET_LOADING", true);
    try {
        const customer = rootGetters["customer/CUSTOMER"];
        const selected_customer = rootGetters["customer/SELECTED_CUSTOMER"];
        const data = { ...payload, customer_id: customer.customer_id };

        if (customer.customer_id === 0) {
            data.customer_id = selected_customer.customer_id;
        }

        const response = await window.axios.post("/proxy/ai/tool-sets", data);
        if (response && response.data.success) {
            commit('SET_CURRENT_TOOL_SET', response.data.toolSet)
        } else {
            throw response.data;
        }
    } catch (error) {
        dispatch("notifications/setError", error.message, { root: true });
    } finally {
        commit("SET_CREATE_TOOL_SET_LOADING", false);
    }
};

export default createToolSet;
